import { useNavigate } from 'react-router-dom';
import React from 'react';
import { DashboardSummary, DashboardSummaryTitle } from '@/components/custom/dashboard';
import { CardIcon } from '@/components/ui/card';

export const DashboardQuickAccess = ({ title, icon, link }) => {
  const navigate = useNavigate();

  return (
    <DashboardSummary
      variant="fast-access"
      onClick={() => navigate(link)}
    >
      <DashboardSummaryTitle>{title}</DashboardSummaryTitle>
      <CardIcon className="size-fit p-2">{icon}</CardIcon>
    </DashboardSummary>
  );
};
